
import { Component, Prop, Vue } from 'vue-property-decorator';

import CloseButton from '@/components/sidebar/CloseButton.vue';
import ChevronIcon from '@/components/icons/ChevronIcon.vue';
import NavigationIcon from '@/components/common/NavigationIcon.vue';

import { Company, User } from '@/generated/graphql';
import { ISidebarNavData, sidebarData } from '@/data/sidebar';
import Roles from '@/entities/Roles';
import InvitationModalWithButton from '@/components/companyContractors/InvitationModalWithButton.vue';
import SidebarItem from '@/components/sidebar/Sidebartem.vue';
import Tooltip from '@/components/common/Tooltip.vue';
import TooltipVariants from '@/entities/TooltipVariants';
import UiButton from '@/components/button/ui-button.vue';
import Logo from "@/components/icons/jobBlissLogo.vue";

@Component({
	components: {
		UiButton,
		Tooltip,
		ChevronIcon,
		CloseButton,
		NavigationIcon,
		InvitationModalWithButton,
		SidebarItem,
		Logo
	},
})
export default class BaseSidebar extends Vue {
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Object, default: undefined }) readonly company?: Company;
	@Prop({ type: Boolean, default: false }) readonly sidebarOpened!: boolean;

	TooltipVariants: typeof TooltipVariants = TooltipVariants;

	get menu(): ISidebarNavData[] {
		return sidebarData.filter((item) =>
			item.role.includes(this.currentUser.role as Roles)
		);
	}

	isDisabledItem(title: String): boolean {
		const disabledItems = ['Job Postings', 'Timesheets', 'Invoicing'];
		return disabledItems.includes(title as string);
	}
}
